module.exports = __webpack_public_path__ + "static/img/home2.db0d309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home2.png
// module id = HqbG
// module chunks = 1